import React from 'react'
import SelectLoginPath from '../feature/Login/SelectLoginPath'

const SelectLoginPathPage = () => {
  return <SelectLoginPath/>
}

export default SelectLoginPathPage
